import permission from '_lib/permission'
import EventBus from '_lib/EventBus'
import { 
  CHANNEL_TYPES, 
  DEFAULT_CHANNEL_PAGE_SIZE, 
  DEFAULT_CHANNEL_PAGE_MAX_COUNT 
} from '@/common/constants/channel';
import store from '@/store';
import Vue from 'vue';
import { ROLE_TYPES } from '_lib/constants/role';
import { 
  CHANNEL_OPERATION_NEW_MEMBER_ABOUT_MAP, 
  MIN_CHATTABLE_CHANNEL_COUNT, 
  MIN_USEABLE_CHANNEL_COUNT,
  NEW_VALUE_IGNORE,
} from '_lib/constants/new-member'
import { getChatableChannelList } from '_api/room';
import unread from '_lib/unreadState';
import { getFlattenChannelSize, getFlattenGroupSize, SCROLLER_ITEM_SIZE } from '_lib/FlatChannel'
import { findChannelSync } from '_js/find-channel';
import { getFullChannelList } from '_api/channel'
import {
  getGlobalTeamInfo,
} from '_api/global-team';


// 遍历频道，设置隐藏频道的显示状态
// 以下操作会影响私密频道的状态
// 1. 频道状态修改 || 增减，对应推送3
// 2. 权限组变更，对应推送3
// 3. 成员权限变更，对应推送43
// 4. 定制频道修改频道显隐
// 因此只对以下三处的channels做处理
// 1. 接口 || ws 返回的channels数据
// 2. 3推送后的channels
// 3. 43推送后的channels
// 4. 定制频道修改过后
export function filterHideChannel(roomInfo, options = { needExit: true }) {
  const channels = roomInfo.channels
  const tempRole = store.getters.temp_role_data
  const tempRoleId = tempRole.temp_role && tempRole.temp_role.id
  const hideGroupIds = store.getters.hide_channel_group_ids[roomInfo.room_id]
  const groupMap = {}
  options = { ...options, tempRoleId }
  if (channels && channels.length) {
    const clearGroupNotShow = (channel) => {
      if (channel.parent_id && groupMap[channel.parent_id]) {
        delete groupMap[channel.parent_id].not_show
        delete groupMap[channel.parent_id].not_show_detail
        delete groupMap[channel.parent_id]
      }
    }
    for (let i = 0; i < channels.length; i++) {
      const channel = channels[i]
      delete channel.not_show
      if (channel.is_private) { // 私密频道单独走权限判断
        delete channel.not_show
        handleChannelNotShow(channel, roomInfo, { showCb: () => clearGroupNotShow(channel), ...options  })
      } else if (channel.channel_type === CHANNEL_TYPES.group) { // 分组的时候，判断是否显示分组有2种情况
        const is_big = roomInfo?.room?.room_setting?.is_big
        const group_has_channel = is_big 
          ? (channel.channel_count && !hideGroupIds?.includes(channel.channel_id)) 
          : channels.some(c => c.parent_id === channel.channel_id)

        if (!group_has_channel) {
          // 没有子频道的时候，根据分组的权限判断是否显示
          handleChannelNotShow(channel, roomInfo, { showCb: null, ...options,  })
        } else {
          // 有子频道的时候，根据子频道是否显示决定分组是否显示
          // 由于分组和频道被拍平了，所有需要先记录分组，在后续遍历频道的时候，再更新分组的展示情况
          channel.not_show = true
          channel.not_show_detail = {}
          groupMap[channel.channel_id] = channel
        }
      } else { // 频道
        handleChannelNotShow(channel, roomInfo, { showCb: () => clearGroupNotShow(channel), ...options })
      }
    }
    console.log('filterHideChannel', JSON.parse(JSON.stringify(channels)))
  }
  return channels
}


/**
 * 通过权限判断是否可见
 * @param {*} channel 当前的频道
 * @param {*} judgeBasic 房间信息，用来做判断
 * @param {*} isPrivate 是否为私密频道
 * @returns 
 */
function checkChannelByPermission(channel, judgeBasic, { tempRoleId }){
  const room = judgeBasic.room
  const is_room_master = store.getters.user_info.user_id == room.create_by
  if(!tempRoleId && is_room_master) return true

  if(tempRoleId){
    judgeBasic = {...judgeBasic, my_roles: [tempRoleId]}
  }
  let judge
  if (!!channel.is_private) {
    judge = permission.judgeShowPrivateChannel({ channel, ...judgeBasic })
  } else {
    judge = permission.judge('ViewingChannel', channel, false, judgeBasic)
  }
  return judge
}

// 通过user_notify_settings中的flags判断是否可见 非公开房间不需要检查 直接开启
function checkChannelByFlags (channel, judgeBasic, { tempRoleId }){
  if(tempRoleId) return true
  
  const { user_notify_settings, room: { is_public, room_setting } } = judgeBasic
  if(!is_public || room_setting?.is_big) return true

  const flags = user_notify_settings[channel.channel_id]?.flags

  return (flags === null || flags === undefined) ? true : !!(+flags)
}

// 判断频道是否为资源频道
export function checkIsResourceChannel(channel, judgeBasic) {
  const isCustomization = !!judgeBasic.room?.customization?.customization_switch
  const hasGuidance = !!judgeBasic.room?.customization?.guidance
  const guidance_channel_list = judgeBasic.room?.customization?.guidance?.resource?.map(item => item.channel_id) ?? []
  return isCustomization && hasGuidance && guidance_channel_list.includes(channel.channel_id)
}

/**
 * 判断频道是否需要notShow
 * @param {*} channel 
 * @param {*} judgeBasic 房间的全量数据cur_room_whole_data
 * @param {*} tempRoleId 
 * @returns [result, detail]
 * result: 是否需要notShow
 * detail: {
 *   permissionNotShow: 是否因为权限不显示
 *   flagsNotShow: 是否因为用户定制不显示
 *   resourceNotShow: 是否因为资源频道而隐藏
 * }
 */
export function checkIsNotShow(channel, judgeBasic, tempRoleId) {
  // 是否因为权限不显示
  const permissionNotShow = !checkChannelByPermission(channel, judgeBasic, { tempRoleId })
  
  // 是否因为用户定制不显示
  const flagsNotShow = !checkChannelByFlags(channel, judgeBasic, { tempRoleId })
  
  // 是否因为资源频道而隐藏
  const resourceNotShow = checkIsResourceChannel(channel, judgeBasic)

  const result = permissionNotShow || flagsNotShow || resourceNotShow
  
  return [
    result,
    {
      permissionNotShow,
      flagsNotShow,
      resourceNotShow,
    }
  ]
}

// 退出频道函数封装
function exitPrivateChannel (channel, cur_text_channel_data, cur_channel_data) {
  if ((channel.channel_type === CHANNEL_TYPES.text && cur_text_channel_data.channel_id === channel.channel_id) 
    || (channel.channel_type === CHANNEL_TYPES.audio && cur_channel_data.channel_id === channel.channel_id)) {
      EventBus.$emit('Channel_Access:exitChannel');
  }
}

/**
 * NotShow赋值函数封装 
 * 统一对私密和普通频道进行
 * @param {*} channel 被判断的频道对象
 * @param {*} judgeBasic 判断函数所需的参数
 * @param {*} options 函数执行的选项
 */
function handleChannelNotShow(channel, judgeBasic, { needExit, showCb, tempRoleId }) {
  channel.room_id = judgeBasic.room_id
  const [result, detail] = checkIsNotShow(channel, judgeBasic, tempRoleId)
  if(result){
    channel.not_show = true
    channel.not_show_detail = detail
    needExit && channel.not_show_detail.permissionNotShow && exitPrivateChannel(channel, store.getters.cur_text_channel_data, store.getters.cur_channel_data)
  }else{
    showCb && showCb()
  }
}

/**
 * 检查开启新手教程功能的房间中，对某些新手教程敏感权限的操作进行检查
 * 1. 如果操作影响 **可聊频道** 的话，只需要 **检查可聊，可聊的临界情况下，可用频道是满足的，并不会影响可用频道**
 * 2. 如果操作影响 **可用频道** 的话，需要检查 **可聊和可用**
 * @param {*} channel_id 需要被检查的频道数据
 * @param {string} op 做了什么操作 对应 `CHANNEL_OPERATION_NEW_MEMBER_ABOUT_MAP` 中的key
 * @param {boolean} newValue 权限修改的新值, 
 */
export const checkChannelOperationIsNotLegal = async (channel_id, op, newValue) => {
  const { available_channels, questions, customization_switch } = store.getters.room_customization;
  if(!customization_switch) return false

  const mayLeadToError = newValue === undefined || NEW_VALUE_IGNORE[op] !== newValue
  if(!mayLeadToError) return false

  // 如果是大房间则不进行判断
  if(store.getters.cur_room_data_is_big){
    return false
  }

  let customizationChannels = [];
  if (available_channels) {
    customizationChannels.push(...available_channels);
  }
  if (questions) {
    const collectList = questions
      .reduce((acc, cur) => {
        const { answers } = cur;
        return [...acc, ...answers.map((answer) => answer.channel_ids)];
      }, [])
      .flat(2);
    customizationChannels.push(...collectList);
  }
  const allSubChannelIds = [...new Set(customizationChannels)];
  const allGroupChannelMap = {};
  for (let i = 0; i < allSubChannelIds.length; i++) {
    const subId = allSubChannelIds[i];
    const subChannel = findChannelSync(subId)
    if (subChannel && subChannel.parent_id) {
      const list = allGroupChannelMap[subChannel.parent_id]
      allGroupChannelMap[subChannel.parent_id] = list ? [...list, subId]  : [subId]
    }
  }
  
  // 得到一个全部的频道列表,并判断是否正在修改相关的频道
  const finalList = [...allSubChannelIds, ...Object.keys(allGroupChannelMap)]; // 在新手教程中的频道都是可用频道
  if(!finalList.includes(channel_id)){
    return false
  }

  // 最终需要判断是那种操作，分开两种情况，影响可用频道和可聊频道 
  const isGroup = Object.keys(allGroupChannelMap).includes(channel_id)
  const cb = isGroup ? ((sid) => {
    return !allGroupChannelMap[channel_id].includes(sid)
  }) : null
  const effectChatable = CHANNEL_OPERATION_NEW_MEMBER_ABOUT_MAP[op]
  /**
   * 后续需要判断是否是分组或者频道
   * 分组的话 需要将所有的子频道剔除
   * 频道的话 直接减1
   */
  const { data: { status, result: { channels: chatables } }} = await getChatableChannelList({
    room_id: store.getters.cur_room_data.room_id,
  })
  if(status === 'ok'){
    const allChatableChannelIds = chatables.filter(c => available_channels.includes(c))
    const result = afterFilter(allChatableChannelIds, true, cb)
    if(effectChatable){
      return result
    }else{
      return result || afterFilter(allSubChannelIds, false, cb)
    }
  } else{
    return true
  }
};

/**
 * 展示提示框
 * @description 如果是不能修改的频道，则展示提示框
 * @param {'edit' | 'del'} type 提示的类型
 */
export const showCantEditDialog = (type) => {
  const data = {
    config: {
      title: type === 'del' ? '无法删除频道' : '无法进行此修改',
      desc: '此频道为新手教程中的默认频道，请先将新手教程更换新的默认频道后修改',
      confirm: {
        text: '我知道了'
      },
    },
  }
  Vue.prototype.$query(data)
}



/**
 * 判断新手教程可用频道函数
 * @param {*} channel 
 * @returns 
 */
export const judgeCanShowInCustomization = (channel, filterPrivate = false) => {
  const { is_private, channel_type, channel_id } = channel;
  
  const notAllowTypes = [CHANNEL_TYPES.temporary];
  const everyoneRole = store.getters.cur_roles_list.find(
    (role) => role.type === ROLE_TYPES.everyone
  );
  const isNotPrivate = !is_private &&
    Vue.prototype.$permission.judgeRole({
      role: everyoneRole,
      type: "ViewingChannel",
      channel_data: channel,
    })
  const result = 
    !notAllowTypes.includes(channel_type) &&
    !store.getters.guidance_channel_list.includes(String(channel_id))
  if(filterPrivate)
    return result && isNotPrivate
  return result
};

/**
 * @description 返回filter过后是否 **不能够** 满足数量
 * @param {string[]} 被filter的频道列表
 * @param {boolean} 是否是影响可聊频道
 * @param {function} cb filter的回调函数
 */
export const afterFilter = (list, isChatable, cb) => {
  const min = isChatable ? MIN_CHATTABLE_CHANNEL_COUNT : MIN_USEABLE_CHANNEL_COUNT
  if(cb) {
    return list.filter(cb).length < min
  } else {
    return list.length <= min
  }
}

/**
 * @description 主播模式 静音同频道用户声音
 */
export const muteCurChannelUserVoice = () => {
  if (!store.getters.cur_channel_data.channel_id) return
  let { user_volumes, screen_share_user_list, user_account_settings, anchor_mode, user_info, anchor_mute_user_ids, cur_channel_data } = store.getters
  let allUserIdList = [...Object.keys(user_volumes), ...screen_share_user_list.map(v => v.user_id), ...(cur_channel_data.members || []).map(v => v.user_id)]
  if (anchor_mode && user_account_settings.anchor_mode_mute_channel) {
    let _anchor_mute_user_ids = {}
    allUserIdList.forEach((v) => {
      if (v != user_info.user_id && !anchor_mute_user_ids[v]) {
        _anchor_mute_user_ids[v] = {
          user_id: v,
          same_channel: true,
        }
      }
    })
    store.commit('SET_ANCHOR_MUTE_USER_IDS', _anchor_mute_user_ids)
    Object.keys(_anchor_mute_user_ids).forEach(user_id => {
      Vue.prototype.$rtc.changeUserVolume(user_id);
    })
  } else if (anchor_mode && !user_account_settings.anchor_mode_mute_channel) {
    const without_same_channel_anchor_mute_user_ids = {}
    for(let key in anchor_mute_user_ids) {
      if(anchor_mute_user_ids[key] && !anchor_mute_user_ids[key].same_channel) {
        without_same_channel_anchor_mute_user_ids[key] = anchor_mute_user_ids[key]
      }
    }
    allUserIdList.forEach(v => {
      if (!without_same_channel_anchor_mute_user_ids[v])
        without_same_channel_anchor_mute_user_ids[v] = {
          user_id: v,
          same_channel: true,
          ignore: true,
        }
    })
    store.commit('SET_ANCHOR_MUTE_USER_IDS', without_same_channel_anchor_mute_user_ids)
    Object.keys(without_same_channel_anchor_mute_user_ids).forEach(user_id => {
      Vue.prototype.$rtc.changeUserVolume(user_id);
    })
  }
}

export const VOLUME_THRESHOLD = 100

// 电流音需求相关的的Slider组件 formatter
export const causeNoiseTipFormatter = (val, threshold = VOLUME_THRESHOLD) => {
  if(val > threshold){
    return `当前音量 ${val} ，可能导致电流音`
  }
  return val
}

/**
 * 获取折叠的数据
 */
export const getCollapseData = (room_info) => {
  const { channels } = room_info
  if (room_info.room?.room_setting?.is_big) {
    for (let channel of channels) {
      if (channel.channel_type === CHANNEL_TYPES.group) {
        setCollapseDataInBigRoom(channel)
      }
    }    
  } else {
    const hideGroupIds = store.getters.hide_channel_all_group_ids
    if (hideGroupIds && hideGroupIds.length){
      for (let i of hideGroupIds){
        const index = channels.findIndex(v => v.channel_id == i)
        if(index === -1){
          continue
        }
        const channel_list = channels.filter(v => v.parent_id === i)
        const collapseData = channel_list.reduce(reduceCollapse, {
          actives: [],
          others: [],
          others_count: 0,
        })
        Vue.set(channels[index], 'collapseData', collapseData)
      }
    }
  }
  return room_info
}

// 更新折叠数据
export const updateCollapseData = (channel, room_info, isGroup = false) => {
  try {
    const { channels } = room_info
    if(!channels) return channels
    const { parent_id, channel_id } = channel
    const group_id = isGroup ? channel_id : parent_id
    const index = channels.findIndex(v => v.channel_id === group_id)
    if(index === -1){
      return channels
    }
    const channelData = channels[index]

    if (room_info.room?.room_setting?.is_big) {
      setCollapseDataInBigRoom(channelData)
      return channels
    }

    const channel_list = channels.filter(v => v.parent_id === group_id)
    const collapseData = channel_list.reduce(
      reduceCollapse, 
      {
        actives: [],
        others: [],
        others_count: 0,
      }
    )
    if(collapseData.actives.length || collapseData.others.length || collapseData.others_count){
      Vue.set(channels[index], 'collapseData', collapseData)
    } else {
      if(channels[index]['collapseData']) {
        Vue.prototype.$delete(channels[index], "collapseData")
      }
    }
    return channels
  } catch (e) {
    if (process.env.IS_PROD && process.env.IS_CLIENT) {
      window.electronAPI.sentryReport(e.message, e.stack)
    }
    return channels
  }
}

// 折叠数据规约函数
const reduceCollapse = (acc, cur) => {
  if(cur.not_show !== undefined && cur.not_show) return acc
  const { channel_id, members, collapse_members, audio_count, room_id } = cur
  // 是否为当前的文字或语音频道 如果是 则加入actives
  if(store.getters.cur_channel_data.channel_id === channel_id || store.getters.cur_text_channel_data.channel_id === channel_id){
    acc.actives.push(cur)
    return acc
  }
  const { redCount } = unread.getUnreadState({
    room_id,
    channel_id: channel_id,
  });
  // 文字频道的计算 获取未读消息 如果有则加入actives
  if(redCount > 0){
    acc.actives.push({ ...cur, unread_count: redCount })
    return acc
  }
  // 语音频道的计算 获取频道语音成员  如果有成员，则加入others
  if (audio_count) {
    acc.others_count += audio_count
  }
  if((members && members.length) ){
    acc.others.push(...members)
    return acc
  } else if (collapse_members && collapse_members.length) {
    acc.others.push(...collapse_members)
    return acc
  }
  return acc
}

const setCollapseDataInBigRoom = async (channel) => {
  if (channel.channel_type === CHANNEL_TYPES.group) {
    const collapseData = {
      actives: [],
      others: [],
      others_count: 0,
    }
    if (store.getters.cur_channel_data.parent_id === channel.channel_id){
      collapseData.actives.push(JSON.parse(JSON.stringify(store.getters.cur_channel_data)))
    }
    if (store.getters.cur_text_channel_data.parent_id === channel.channel_id) {
      collapseData.actives.push(JSON.parse(JSON.stringify(store.getters.cur_text_channel_data)))
    }
    if (channel.audio_count && channel.audio_users) {
      const real_users = channel.audio_users?.filter(v => !store.getters.cur_channel_data?.members?.some(v2 => v2.user_id === v.user_id))
      collapseData.others_count = channel.audio_count - (channel.audio_users.length - real_users.length)
      collapseData.others.push(...real_users)
    }
    Vue.set(channel, 'collapseData', collapseData)
  }
}

// 判断频道是否可见
export function isChannelVisible(channel) {
  return !store.getters.hide_channel_all_group_ids.includes(channel.parent_id) && !channel.not_show
}

// 获取可见频道数量
export function getVisibleChannelLength(channels) {
  return channels.filter(channel => isChannelVisible(channel)).length
}

// 删除指定数量可见频道
export function delVisibleChannels(channels, nums, direction = 'pre') {
  if (!nums || nums <= 0) return channels
  const index = [0, channels.length - 1]
  let delVisibleNum = 0, delNums = 0

  // 封装重复的处理逻辑
  const processChannel = (channel, i) => {
    if (isChannelVisible(channel)) {
      index[direction === 'pre' ? 0 : 1] = i
      delVisibleNum++
    }
    delNums++
    return delVisibleNum === nums
  }

  if (direction === 'pre') {
    for (let i in channels) {
      if (processChannel(channels[i], i)) break
    }
  } else if (direction === 'post') {
    for (let i = channels.length - 1; i >= 0; i--) {
      if (processChannel(channels[i], i)) break
    }
  }

  console.log('delVisibleChannels', index[0], index[1])
  return {
    channels: channels.slice(index[0], index[1] + 1),
    delNums,
  }
}

export function calcChannelsHeight(channels, {startIndex = 0, needSplitIndex = 0 } = {}) {
  let height = 0
  for (let i = startIndex; i < channels.length; i++) {
    const channel = channels[i]
    if (isChannelVisible(channel)) {
      if (channel.channel_type === CHANNEL_TYPES.group) {
        height += getFlattenGroupSize(channel, i + startIndex > needSplitIndex)
      } else {
        height += getFlattenChannelSize(channel)
      }
    }
  }
  console.log('calcChannelsHeight', height, channels)
  return height
}

export function calcChannelSkeletonHeight(nums) {
  return nums * SCROLLER_ITEM_SIZE.channel
}


export function getChannelsInRoomInfo(room_info) {
  // 1.39 后台新增channels_v2字段，新版本频道列表都用channels_v2
  if (room_info.channels_v2) {
    room_info.channels = room_info.channels_v2
    delete room_info.channels_v2
  }
  return room_info.channels
}

export function getChannelPageConfig() {
  const { global_config } = store.getters
  const { channel_page_size, channel_page_max_count } = global_config?.numbers || {}
  return {
    CHANNEL_PAGE_SIZE: channel_page_size || DEFAULT_CHANNEL_PAGE_SIZE,
    CHANNEL_PAGE_MAX_COUNT: channel_page_max_count || DEFAULT_CHANNEL_PAGE_MAX_COUNT,
  }
}

export async function getChannelByPage(params) {
  let res = await getFullChannelList(params)
  if (res.data.status === 'ok') {
    return res.data.result.channels
  }
  return []
}

export async function handleEnterGlobalTeam(team_id) {
  const {
    data: { status, result },
  } = await getGlobalTeamInfo({
    team_id: team_id,
  });
  if (status === 'ok') {
    const { res } = result || {};
    store.commit('SET_CUR_GLOBAL_TEAM', res);
    // 如果当前用户在组队内 则直接加入语音
    if(res.members?.some(member => member.heybox_id == store.getters.user_info.user_id)) {
      EventBus.$emit('GlobalTeam:joinTeamAudio', team_id);
    }
  }
}